// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Dropdown-module__dropdown-panel___zZafj{transform:translateY(8px);border-radius:6px}", "",{"version":3,"sources":["webpack://./src/redesign/components/Dropdown/Dropdown.module.scss"],"names":[],"mappings":"AAAA,yCACE,yBAAA,CACA,iBAAA","sourcesContent":[".dropdown-panel {\n  transform: translateY(8px);\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown-panel": "Dropdown-module__dropdown-panel___zZafj",
	"dropdownPanel": "Dropdown-module__dropdown-panel___zZafj"
};
export default ___CSS_LOADER_EXPORT___;
